export default __webpack_public_path__ + "static/media/mTop_2_p3.2d2645e9.jpeg";